module.exports = __webpack_public_path__ + "static/media/logo_wise_white.6c6aa865.png";